import { render, staticRenderFns } from "./chat-message-status.vue?vue&type=template&id=124398ea&scoped=true"
import script from "./chat-message-status.vue?vue&type=script&lang=js"
export * from "./chat-message-status.vue?vue&type=script&lang=js"
import style0 from "./chat-message-status.vue?vue&type=style&index=0&id=124398ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124398ea",
  null
  
)

export default component.exports